import message from 'antd/lib/message';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/store';
import { updateUser } from 'shared/store/auth-slice';
import { selectActiveUser } from 'shared/store/shared-selectors';
import { UserSettings } from 'types/user';

export const useUpdateUserOutboundSettings = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectActiveUser);
  const [settings, setSettings] = React.useState<UserSettings>(
    user?.settings as UserSettings,
  );

  const handleUpdateUserOutboundSettings = React.useCallback(
    updatedSettings => {
      dispatch(
        updateUser({
          displayName: user?.displayName,
          avatar: user?.avatar,
          title: user?.title,
          settings: updatedSettings,
        }),
      )
        .then(() => {
          message.success('Dialer settings updated');
        })
        .catch(err => {
          message.success(err.message);
        });
    },
    [dispatch, user?.avatar, user?.displayName, user?.title],
  );

  const updateSettings = React.useCallback(
    (key: keyof UserSettings, value) => {
      setSettings(prev => {
        const update = { [key]: value };

        handleUpdateUserOutboundSettings(update);

        return { ...prev, ...update };
      });
    },
    [handleUpdateUserOutboundSettings],
  );

  useEffect(() => {
    setSettings(user?.settings as UserSettings);
  }, [user?.settings]);

  return { settings, updateSettings };
};
